export class WtpRentalPropertyRequestData {
    constructor(propertyId: number, propertyType: number, isStringValue: boolean, propertyNumericValue: number, propertyTextValue: string) {
        this.propertyId = propertyId;
        this.propertyType = propertyType;
        this.isStringValue = isStringValue;
        this.propertyNumericValue = propertyNumericValue;
        this.propertyTextValue = propertyTextValue;
    }

    propertyId: number;
    propertyType: number;
    propertyNumericValue: number;
    propertyTextValue: string;
    isStringValue: boolean;
}